import { render, staticRenderFns } from "./QuestionaireTemplateItem.vue?vue&type=template&id=5effd471&scoped=true"
import script from "./QuestionaireTemplateItem.vue?vue&type=script&lang=js"
export * from "./QuestionaireTemplateItem.vue?vue&type=script&lang=js"
import style0 from "./QuestionaireTemplateItem.vue?vue&type=style&index=0&id=5effd471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5effd471",
  null
  
)

export default component.exports